// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContentSection from "common/src/ContentSection.bs.js";

function InfoSectionHeader(Props) {
  var title = Props.title;
  return React.createElement(ContentSection.make, {
              className: "mt-12 flex items-center justify-center mb-6 gap-8 border-secondary-11 border-b-2 border-b-2 min-w-[350px] max-w-[600px] leading-tight",
              children: React.createElement("h2", {
                    className: "text-xl font-montserrat font-medium flex-shrink-0"
                  }, title)
            });
}

var make = InfoSectionHeader;

export {
  make ,
  
}
/* react Not a pure module */
